import { render, staticRenderFns } from "./AdvertisingDetailPage.vue?vue&type=template&id=b4ea82ce&scoped=true&"
import script from "./AdvertisingDetailPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisingDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingDetailPage.vue?vue&type=style&index=0&id=b4ea82ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ea82ce",
  null
  
)

export default component.exports
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js"
import QPage from 'quasar/src/components/page/QPage.js'
import QIcon from 'quasar/src/components/icon/QIcon.js'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js'
import QBtn from 'quasar/src/components/btn/QBtn.js'
import QInput from 'quasar/src/components/input/QInput.js'
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js'
import QAvatar from 'quasar/src/components/avatar/QAvatar.js'
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js'
qInstall(component, 'components', {QPage,QIcon,QSkeleton,QBtn,QInput,QLinearProgress,QAvatar,QTooltip})
